module.exports = __webpack_public_path__ + "img/lawyer-pain-point-3.bc8e73cd.png";